<template>
  <div class="newsletter-box mt-45">
    <h5 class="title">Newsletter</h5>
    <p>您的邮箱仅用于订阅，不会对外公开</p>
    <form action="#">
      <div class="input-box">
        <input type="email" placeholder="请输入您的邮箱" v-model="email" />
        <button type="button" @click="handleSubmit">提交</button>
      </div>
      <span v-if="showEmailError" style="color: #fc5531; font-size: 12px;">{{ emailErrorMsg }}</span>
    </form>
    <span style="padding-top: 15px!important;">绝不推送垃圾邮件，请放心订阅</span>

    <LoginRegisterDialog
      :visible="dialogVisible"
      @update:visible="(val) => dialogVisible = val"
      @registerSuccess="handleProfilePage"
    />

  </div>
</template>

<script>
import profileService from '@/utils/profileService';
import LoginRegisterDialog from '@/components/Common/LoginRegisterDialog.vue';
export default {
  components: {
    LoginRegisterDialog
  },
  data() {
    return {
      // 控制登录对话框显示状态
      dialogVisible: false,
      // 添加邮箱数据绑定和错误提示相关属性
      email: '',
      showEmailError: false,
      emailErrorMsg: ''
    };
  },
  computed: {
    userProfile() {
      return profileService.getProfile();
    }
  },
  methods: {
    // 提交按钮点击事件处理
    handleSubmit() {
      // 邮箱格式验证逻辑
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email) {
        this.showEmailError = true;
        this.emailErrorMsg = '请输入邮箱地址';
        return;
      } else if (!emailReg.test(this.email)) {
        this.showEmailError = true;
        this.emailErrorMsg = '请输入正确的邮箱格式';
        return;
      } else {
        this.showEmailError = false;
      }

      // 判断用户是否已登录
      if (!this.userProfile || !this.userProfile.id) {
        // 未登录，显示登录对话框
        this.dialogVisible = true;
      } else {
        const token = localStorage.getItem('token');
        if (token) {
          this.handleProfilePage(token);
        }
      }
    },
    async handleProfilePage(token) {
      if (token) {
        this.$router.push({ 
          name: 'Profile', 
          query: { tab: '1', email: this.email }
        });
      }
    },
  }
};
</script>

<style>
.newsletter-box span{
  padding-top: 0 !important;
}
</style>
